import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetCharges } from "../../../store/charge-store/charge-actions";
import ABADatatable from "../../../components/ABADatatable";
import { chargeActions } from "../../../store/charge-store/charge-slice";
import { Button } from "primereact/button";

const ChargeHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const charges = useSelector((state) => state.charge.charges);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.roles !== undefined && auth.roles.includes("charge.showAll")) {
      dispatch(GetCharges(auth.UserInfo.email, true, true));
    }
  }, [dispatch, auth]);

  const viewDetailHanlder = (val) => {
    navigate(`/charge/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/charge/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      chargeActions.setCharge({
        charge: {
          id: 0,
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/charge/create`);
  };
  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (auth.roles !== undefined && auth.roles.includes("charge.edit")) {
      buttons.push(buttonEdit);
    }
    if (auth.roles !== undefined && auth.roles.includes("charge.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];
  return (
    <>
      <ABADatatable
        width="20%"
        title="Cargos"
        values={charges}
        rows={5}
        rowsPerPageOptions={[5, 10, 20]}
        Columns={columns}
        actions={actions}
        createButton={{
          label: "Crear Cargo",
          onClick: createHanlder,
          permission: "charge.create",
        }}
        backButton={{
          label: "Regresar",
          onClick: backHanlder,
          permission: "goBack",
        }}
      />
    </>
  );
};
export default ChargeHomePage;
